import { css } from "lit-element";
// https://lit.dev/docs/components/styles/#expressions
// noinspection CssUnresolvedCustomProperty,CssNoGenericFontName
export const commonCssStyles = css `
  :host {
    --dark-gray-color: #343434;
    --white-color: #fff;
    --orange-color: #ff7239;
    --neutral-dark-10-color: #f3f3f3;
    --neutral-dark-20-color: #d9d9d9;
    --text-text-white-color: #fff;
    --text-text-color: #343434;
    --text-text-weak-color: #5a5a5a;
    --tones-lavender10-color: #f2edff;
    --tones-lavender50-color: #794dff;
    --tones-lavender60-color: #650ba5;
    --tones-lavender60-disabled-color: #613eccd1;
    --tones-lavender70-color: #510984;
    --button-success: #00864e;
    --Neutral-Dark-Helix-0: #fff;
    --text-font-family: "Montserrat", "Helvetica", "Arial", sans-serif;
    --dropdown-transition: all 200ms ease-out;
    --delay-transition75: all 75ms cubic-bezier(0, 0, 0.58, 1);
    --delay-transition125: all 125ms cubic-bezier(0, 0, 0.58, 1);
    --margin-s: 24px;
    --margin-m: 32px;
    --margin-l: 32px;
    --margin-xl: auto;
    --inner-content-max-width: 1216px;
    --spacing-2xs: 4px;
    --spacing-xs: 8px;
    --spacing-sm: 12px;
    --spacing-md: 16px;
    --spacing-lg: 24px;
    --spacing-xl: 32px;
    --spacing-2xl: 40px;
    --spacing-4xl: 56px;
  }

  .text-xxs-semibold {
    font-family: var(--text-font-family);
    font-size: 10px;
    font-weight: 600;
    font-style: normal;
  }

  .text-body-s-regular {
    font-family: var(--text-font-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .text-base-semibold {
    font-family: var(--text-font-family);
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
  }

  .drop-shadow-10 {
    box-shadow:
      0px 0px 32px -12px rgba(115, 115, 115, 0.24),
      0px 0px 4px 0px rgba(115, 115, 115, 0.16);
  }

  /* Defending against Global Styles / CSS Resets
  Consuming applications will sometimes set global styles, called a CSS
  reset: https://www.joshwcomeau.com/css/custom-css-reset/ If those styles
  interfere with these components, we can override them here. */
  * {
    line-height: normal;
  }
`;
